/**
 * How a Pokémon's Special Conditions show on the board, the way the rulebook says to show them with real cards
 * (page 14, "Card Positions"; page 15): Asleep turns the card sideways to the left, Paralyzed sideways to the right,
 * Confused upside down; Poisoned puts a poison marker on it (and Burned a burn marker). Any condition with no way to
 * show is left as words.
 *
 * @param {string[]} conditions the condition names the server sends, like "Asleep" or "Badly Poisoned"
 * @returns {{ turn: number, markers: string[], words: string[] }} degrees to turn the card (clockwise), the markers
 *   to put on it ('poison', 'bad-poison', 'burn'), and the conditions still to say in words
 */
export function conditionDisplay(conditions) {
  const TURNS = { Asleep: -90, Paralyzed: 90, Confused: 180 };
  const MARKERS = { Poisoned: 'poison', 'Badly Poisoned': 'bad-poison', Burned: 'burn' };
  let turn = 0;
  const markers = [];
  const words = [];

  conditions.forEach((condition) => {
    if (TURNS[condition] !== undefined) {
      turn = TURNS[condition];
    } else if (MARKERS[condition]) {
      markers.push(MARKERS[condition]);
    } else {
      words.push(condition);
    }
  });

  return { turn, markers, words };
}
